module.exports = __webpack_public_path__ + "img/icon_work_04.b898794d.png";